// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__sbay5","legacyBtn":"MutateMid_legacyBtn__3QnuG"};